import React, { useState } from 'react';

 
import TrainingStatusModal from './TrainingStatusModal';
import ConfirmationModal from '../../ConfirmationModal';
import RequestorListActionsDropdown from './RequestorListActionsDropdown';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';


const RequestorTableRow = ({ requestor, handleChangeStatus,handleDeleteRequestor, fetchRequestorList }) => {
    const navigate = useNavigate();
    const [showTrainingModal, setShowTrainingModal] = useState(false);
    const [trainingCompleted, setTrainingCompleted] = useState(requestor.training_completed);
    const [trainingDate, setTrainingDate] = useState(requestor.training_completed_date ? new Date(requestor.training_completed_date) : null);

    const handleShowTrainingModal = () => setShowTrainingModal(true);
    const handleCloseTrainingModal = () => setShowTrainingModal(false);

    const handleSaveTrainingStatus = () => {
        handleCloseTrainingModal();
    };
    const handleEditRequestor = () => {
    
        navigate(`requestor-profile/${requestor.id}`);
    };

    const [showDeactivateModal, setShowDeactivateModal] = useState(false);

    const handleShowDeactivateModal = () => setShowDeactivateModal(true);
    const handleCloseDeactivateModal = () => setShowDeactivateModal(false);

    const confirmDeactivateUser = () => {
        handleChangeStatus(requestor, requestor.active);
        handleCloseDeactivateModal();
    };

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const confirmDeleteUser = () => {
        handleDeleteRequestor(requestor.id);
        handleCloseDeleteModal();
    };
    const isMobile = useMediaQuery({ maxWidth: 768 });

    return (
        <>
        {isMobile ? (
           <div className="admin-card-list">
          
             <div className="admin-card el-bg-table mb-2" >

               <div className="card-header">

               <div className="card-actions" style={{height:'10px'}}>
                <div style={{float:'right'}}>
                <RequestorListActionsDropdown requestor={requestor} handleEditRequestor={handleEditRequestor} handleShowTrainingModal={handleShowTrainingModal} handleShowDeactivateModal={handleShowDeactivateModal}  handleShowDeleteModal={handleShowDeleteModal}/> 
                </div>
                 


               </div>
                 <h5>{requestor.first_name} {requestor.middle_name} {requestor.last_name}</h5> 
               </div>
                
               <div className=  {"card-body "} >
                  <p> <strong>Location:</strong>{" "}{requestor.lab_name}</p>
                 <p><strong>Training Completed:</strong> {requestor.training_completed ? (
                        `Yes - ${new Date(requestor.training_completed_date).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        })}`
                    ) : (
                        "No"
                    )}</p>
                 
                 <p>
                   <strong>Status:</strong>{" "}
                   <span className={requestor.active ? "badge bg-success" : "badge bg-danger"}>
                     {requestor.active ? "Active" : "Inactive"}
                   </span>
                 </p>
               </div>
          
             </div>
           
         </div>
         ):(<>


            <tr>
                <td>{requestor.first_name} {requestor.middle_name} {requestor.last_name}</td>
                <td>{requestor.lab_name}</td>
                <td>
                    <div className={requestor.active ? "el-active" : "el-inactive"}>
                        <div className={requestor.active ? "el-activebtn" : "el-inactive"}></div>
                        {requestor.active ? "Active" : "Inactive"}
                    </div>
                </td>
                <td> 
                    {requestor.training_completed ? (
                        `Yes - ${new Date(requestor.training_completed_date).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        })}`
                    ) : (
                        "No"
                    )}
                </td>
                <td>
                    <RequestorListActionsDropdown requestor={requestor} handleEditRequestor={handleEditRequestor} handleShowTrainingModal={handleShowTrainingModal} handleShowDeactivateModal={handleShowDeactivateModal}  handleShowDeleteModal={handleShowDeleteModal}/> 
                </td>
            </tr>
            </>
            )}
            <TrainingStatusModal
                show={showTrainingModal}
                handleClose={handleCloseTrainingModal}
                handleSaveTrainingStatus={handleSaveTrainingStatus}
                requestor={requestor}
                fetchRequestorList={fetchRequestorList}
            />
            <ConfirmationModal
                show={showDeactivateModal}
                onHide={handleCloseDeactivateModal}
                onConfirm={confirmDeactivateUser}
                title=""
                body={`Are you sure you want to ${requestor.active ? 'deactivate' : 'activate'} user?`}
                type='deactivateactivate'
            />
               <ConfirmationModal
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onConfirm={confirmDeleteUser}
                title=""
                body={`Are you sure you want to delete user?`}
                type='delete'
            />
        </>
    );
};
export default RequestorTableRow;
